<template>
  <div class="ui-container">
    <h2>Colors</h2>
    <h3>Primary</h3>
    <div class="ui-block inline">
      <div v-for="index in 10" :key="index" class="card-color">
        <div
          class="card-color-body"
          :class="`bg-primary-${(index - 1 >= 1 ? index - 1 : 0.5) * 100}`"
        />
        <div
          class="card-color-footer"
          v-text="`Primary-${(index - 1 >= 1 ? index - 1 : 0.5) * 100}`"
        />
      </div>
    </div>
    <h3>Secondary</h3>
    <div class="ui-block inline">
      <div v-for="index in 10" :key="index" class="card-color">
        <div
          class="card-color-body"
          :class="`bg-secondary-${(index - 1 >= 1 ? index - 1 : 0.5) * 100}`"
        />
        <div
          class="card-color-footer"
          v-text="`Secondary-${(index - 1 >= 1 ? index - 1 : 0.5) * 100}`"
        />
      </div>
    </div>
    <h3>Red</h3>
    <div class="ui-block inline">
      <div v-for="index in 10" :key="index" class="card-color">
        <div
          class="card-color-body"
          :class="`bg-red-${(index - 1 >= 1 ? index - 1 : 0.5) * 100}`"
        />
        <div
          class="card-color-footer"
          v-text="`Red-${(index - 1 >= 1 ? index - 1 : 0.5) * 100}`"
        />
      </div>
    </div>
    <h3>Green</h3>
    <div class="ui-block inline">
      <div v-for="index in 10" :key="index" class="card-color">
        <div
          class="card-color-body"
          :class="`bg-green-${(index - 1 >= 1 ? index - 1 : 0.5) * 100}`"
        />
        <div
          class="card-color-footer"
          v-text="`Green-${(index - 1 >= 1 ? index - 1 : 0.5) * 100}`"
        />
      </div>
    </div>
    <h3>Orange</h3>
    <div class="ui-block inline">
      <div v-for="index in 10" :key="index" class="card-color">
        <div
          class="card-color-body"
          :class="`bg-orange-${(index - 1 >= 1 ? index - 1 : 0.5) * 100}`"
        />
        <div
          class="card-color-footer"
          v-text="`Orange-${(index - 1 >= 1 ? index - 1 : 0.5) * 100}`"
        />
      </div>
    </div>
    <h3>Others</h3>
    <div class="ui-block inline">
      <div v-for="color in otherColors" :key="color" class="card-color">
        <div class="card-color-body" :style="`background: ${color.code}`" />
        <div class="card-color-footer" v-text="color.name" />
      </div>
    </div>
  </div>
</template>

<script setup>
const otherColors = [
  {
    name: "white",
    code: "#FFFFFF",
  },
  {
    name: "light-white",
    code: "#F2F2F1",
  },
  {
    name: "light-grey",
    code: "#E5E5E5",
  },
  {
    name: "black",
    code: "#000000",
  },
];
</script>
